import { useEffect, useId, useMemo, useRef, useState } from "react";
import { Col, FormGroup, FormText, Input, Label, Row } from "reactstrap";
import { Api } from "../../shared";
import { Tax } from "../../shared/api";

export type IProps = {
	taxes: Tax.TaxType[];
	onChange: (taxes: Tax.TaxType[]) => void;
};

type Info = {
	taxes: Map<number | null, Tax.TaxType>;
	countries: Tax.CountryType[];
};

export const ProductTaxes = (props: IProps) => {

	const taxes = useMemo(() => {
		let taxes = new Map<string, Tax.TaxType>();
		for(let tax of props.taxes) {
			if(!tax.is_default) {
				taxes.set(tax.country, tax);
			}
		}
		return taxes;
	}, []);

	const [info, setInfo] = useState<Info | null>(null);

	useEffect(() => {(async () => {
		let res = await Api.Staff.Tax.Call.getAll({});
		if (!res.data) throw res.error;

		let taxes: Map<number | null, Tax.TaxType> = new Map();

		for(let tax of res.data.taxes) {
			taxes.set(tax.id, tax);
		}

		setInfo({ taxes, countries: res.data.countries });

	})()}, []);
	
	let label_id_base = useId();

	if(info === null) {
		return (
			<FormGroup>
				<Label>Taxes</Label>
			</FormGroup>
		);
	}

	let country_elems: JSX.Element[] = [];

	const on_change = (country: Tax.CountryType, tax_id: string) => {
		if(tax_id === "") {
			taxes.delete(country.code);
		} else {
			let tax = info.taxes.get(parseInt(tax_id));
			if(tax) {
				taxes.set(country.code, tax);
			}
		}
		props.onChange([...taxes.values()]);
	}

	for(let country of info.countries) {
		let tax_elems: JSX.Element[] = [];
		let label_id = `${label_id_base}-${country.code}`;
		let label_default: string | undefined;

		for(let tax of info.taxes.values()) {
			if(tax.country == country.code) {
				let label = `${tax.label} ${(tax.rate * 100).toLocaleString()}%`;
				tax_elems.push(<option key={tax.id} value={tax.id ?? ""}>{label}</option>);

				if(country.tax_id === tax.id) {
					label_default = label;
				}
			}
		}

		country_elems.push(
			<Col key={country.code}>
				<Label htmlFor={label_id}>{country.label} ({country.tax_type})</Label>
				<Input
					id={label_id}
					type="select"
					onChange={(e) => on_change(country, e.target.value)}
					defaultValue={taxes.get(country.code)?.id ?? ""}
				>
					<option value="">Default: {label_default ?? "None"}</option>
					{tax_elems}
				</Input>
			</Col>
		);
	}

	return (
		<FormGroup>
			<Label>Taxes</Label>
			{country_elems}
		</FormGroup>
	);
}

